import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {IGuidelineDetail} from '@entities/tieu-chuan/tieu-chuan.model';
import {JhiEventManager} from 'ng-jhipster';
import {TieuChuanService} from '@entities/tieu-chuan/tieu-chuan.service';

@Component({
  selector: 'app-activity-type-delete-dialog',
  templateUrl: './activity-type-delete-dialog.component.html',
})
export class ActivityTypeDeleteDialogComponent {
  guideline: IGuidelineDetail;

  @HostListener('window:keyup.esc')
  private onKeyUp() {
    this.dialogRef.close();
  }
  constructor(
    private dialogRef: MatDialogRef<ActivityTypeDeleteDialogComponent>,
    private eventManager: JhiEventManager,
    private tieuChuanService: TieuChuanService,
  ) {}

  confirmDelete(id: any) {
    this.tieuChuanService
      .deleteActivityGuidelineDetail(id)
      .subscribe((response) => {
        this.eventManager.broadcast({
          name: 'activityDetailModification',
          content: 'guideline',
        });
        this.dialogRef.close(true);
      });
  }
}

@Component({
  selector: 'app-activity-type-delete-popup',
  template: '',
})
export class ActivityTypeDeletePopupDialogComponent
  implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<ActivityTypeDeleteDialogComponent>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.tieu-chuan.activity-type-delete-dialog.Xóa chi tiết hoạt động_title',
      ),
    );
    this.activatedRoute.data.subscribe(({guideline}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(ActivityTypeDeleteDialogComponent, {
          disableClose: true,
          width: '380px',
        });
        this.dialogRef.componentInstance.guideline = guideline;
        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }
  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant('common.title.Chi tiết quy trình'),
    );
    this.dialogRef = null;
  }
}
